<template>
  <div class="app-burger-menu" :class="isOpen && 'open'" v-on-clickaway="closeMenu">
    <!-- menu toogle -->
    <AppButtonIcon class="app-burger-menu__toggle ripple" :icon="menuIcon" @click="toggleMenu" />
    <transition v-bind:css="true" name="burger-menu-right">
      <div v-if="isOpen" class="app-burger-menu__content">
        <slot name="menu-content" :close-menu="closeMenu" />
      </div>
    </transition>
  </div>
</template>

<script>
// Utilities
import { mixin as clickaway } from 'vue-clickaway'
// Components
import AppButtonIcon from 'Ui/AppButtonIcon'

export default {
  name: 'AppBurgerMenu',

  components: {
    AppButtonIcon,
  },

  props: {
    openIcon: {
      type: String,
      default: 'fas fa-bars',
    },

    closeIcon: {
      type: String,
      default: 'fas fa-times',
    },
  },
  mixins: [clickaway],

  data() {
    return {
      isOpen: false,
    }
  },

  methods: {
    toggleMenu() {
      this.isOpen = !this.isOpen
    },

    closeMenu() {
      this.isOpen = false
    },
  },

  computed: {
    menuIcon() {
      return this.isOpen ? this.closeIcon : this.openIcon
    },
  },
}
</script>

<style scoped>
.app-burger-menu {
  --t-opacity: 0.3s;
  --t-transform: 0.35s;
  display: flex;
  flex-direction: column;
  position: fixed;
  right: 10px;
  bottom: 70px;
  z-index: 20;
  transition: all 0.3s;
}

.app-burger-menu__toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  border-radius: 50px;
  width: 40px;
  height: 40px;
  padding: 8px;
  background-color: var(--rgba-primary-700);
}

.open .app-burger-menu__toggle {
  background-color: var(--c-primary);
}

.app-burger-menu__content {
  position: absolute;
  min-width: 200px;
  min-height: 200px;
  padding: 10px;
  border-radius: 5px;
  background-color: #fff;
  backface-visibility: hidden;
  box-shadow: 0 2px 10px -3px var(--rgba-default);
  border: 1px solid var(--c-gray-300);
  will-change: transform, scale;
  transform: translate(-100%, -100%);
}

/* translate from right */
.burger-menu-right-enter-active,
.burger-menu-right-leave-active {
  transition: opacity var(--t-opacity), transform var(--t-transform) !important;
}

.burger-menu-right-leave-to {
  transform: scale(0.3) translate(-160%, -160%) !important;
}

.burger-menu-right-enter {
  transform: scale(0.3) translate(-160%, -160%) !important;
}
</style>
